<template>
  <div class="container ">
    <GamesPermissionComponent />
  </div>
</template>

<script>
import GamesPermissionComponent from "../components/GamesPermissionComponent";
export default {
  name: "GamesPermissions.container",
  components: { GamesPermissionComponent }
};
</script>

<style scoped>
.root {
  height: 100%;
  font-family: Montserrat !important;
}
</style>
